import { useEffect} from 'react';
import { NavLink } from "react-router-dom";
import CguContenu from '../Components/CguContenu.jsx';

/**
 * Return Page Cgu
 *
 * @component
 * @summary Cgu
 * @param {  }
 * @return { HTMLElement }
*/
function Cgu() {
    useEffect(() => {
      document.title = "Conditions Générales d'Utilisation de la Base de données Régionale de l’Offre de Formation (BROF)";
    }, []);

    return (
        <>
            <div className='cgu-titre'>
                <strong>Conditions G&eacute;n&eacute;rales d'Utilisation<br />de la Base de donn&eacute;es R&eacute;gionale de l&rsquo;Offre de Formation<br />(BROF)</strong>
            </div>

            <div onClick={() => window.history.back()} className="normal-navig-item"><span className="fas fa-circle-chevron-left"></span>Retour à la page précédente</div>

            <div className='logo-login'>
                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/logo_CarifOref.png`} alt="Carif Oref Paca" className="feature-icon" /></NavLink>
            </div>

            <CguContenu />
        </>
    )

}

export default Cgu;